module.exports = __webpack_public_path__ + "static/media/large-transparent-logo.2a44b9e9.png";